import React, {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import SearchInput from '../../../uiToolkit/Inputs/SearchInput';
import {microlessonsLibraryText} from '../microlessonsLibraryText';
import './styles.css';
import {Microlesson} from '../../../data/models/Microlessons/Microlesson';
import MicrolessonsLibraryCard from '../components/MicrolessonLibraryCard';
import TablePagination from '../../../uiToolkit/TablePagination';
import {ITEMS_PER_PAGE} from '../container/MicrolessonsLibraryContainer';
import Button from '../../../uiToolkit/Buttons/Button';
import MicrolessonsEmptyState from '../../../uiToolkit/EmptyStates/MicrolessonsEmptyState';

interface Props {
  search: string;
  setSearch: (search: string) => void;
  onCancel: () => void;
  lessons: Microlesson[];
  currentPage: number;
  pages: number;
  onPageChange: (page: number) => void;
  onSelectLesson: (microlesson: Microlesson) => void;
  isLoading: boolean;
  onCreateLesson: () => void;
}

const MicrolessonsLibraryUI = React.memo(
  ({
    search,
    setSearch,
    onCancel,
    lessons,
    currentPage,
    pages,
    onPageChange,
    onSelectLesson,
    isLoading,
    onCreateLesson,
  }: Props) => {
    const [selectedMicrolesson, setSelectedMicrolesson] =
      useState<Microlesson>();

    const onConfirmSelection = () => {
      if (selectedMicrolesson) {
        onSelectLesson(selectedMicrolesson);
      }
    };

    return (
      <div className="MicrolessonsModal">
        <Container fluid>
          <Row>
            <Col xl={{offset: 3, span: 6}} lg={{offset: 2, span: 8}}>
              <div className="MicrolessonsModalContainer">
                <div className="Header">
                  <h1>{microlessonsLibraryText.title}</h1>
                  <button className="CloseButton" onClick={onCancel}>
                    <span className="icon-x-close"></span>
                  </button>
                </div>
                <div className="SearchContainer">
                  <SearchInput value={search} onChange={setSearch} />
                </div>

                <Container className="LessonsContainer">
                  <Row>
                    {lessons.length ? (
                      lessons.map(lesson => (
                        <Col xs={4} key={lesson.id} className="d-flex">
                          <MicrolessonsLibraryCard
                            lesson={lesson}
                            onSelectLesson={setSelectedMicrolesson}
                            selected={selectedMicrolesson?.id === lesson.id}
                          />
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}>
                        <MicrolessonsEmptyState
                          onCreate={onCreateLesson}
                          canCreateCourses
                        />
                      </Col>
                    )}
                  </Row>
                </Container>
                {lessons.length ? (
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <TablePagination
                          currentPage={currentPage}
                          rowCount={pages * ITEMS_PER_PAGE}
                          rowsPerPage={ITEMS_PER_PAGE}
                          onChangePage={onPageChange}
                        />
                      </Col>
                    </Row>
                  </Container>
                ) : null}
                {lessons.length ? (
                  <div className="d-flex flex-row justify-content-center mt-3">
                    <Button
                      uiType="action"
                      title={microlessonsLibraryText.select}
                      disabled={!selectedMicrolesson}
                      onClick={onConfirmSelection}
                      isLoading={isLoading}
                    />
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  },
);

export default MicrolessonsLibraryUI;
